// extracted by mini-css-extract-plugin
export default {"showApp":"App_showApp__pZ7KM"};